import { JSXElementConstructor } from 'react';
import { ConversationMessageContentType } from 'src/@types/conversation';
import { ConversationMessageContentAudio } from './ConversationMessageContentAudio';
import { ConversationMessageContentFile } from './ConversationMessageContentFile';
import { ConversationMessageContentFileCompact } from './ConversationMessageContentFileCompact';
import { ConversationMessageContentImage } from './ConversationMessageContentImage';
import { ConversationMessageContentSoundBoard } from './ConversationMessageContentSoundBoard';
import { ConversationMessageContentText } from './ConversationMessageContentText';
import { IConversationMessageContentProps } from './types';

const components: Record<
  ConversationMessageContentType,
  JSXElementConstructor<IConversationMessageContentProps>
> = {
  [ConversationMessageContentType.AUDIO]: ConversationMessageContentAudio,
  [ConversationMessageContentType.FILE]: ConversationMessageContentFile,
  [ConversationMessageContentType.IMAGE]: ConversationMessageContentImage,
  [ConversationMessageContentType.VIDEO]: ConversationMessageContentImage,
  [ConversationMessageContentType.TEXT]: ConversationMessageContentText,
  [ConversationMessageContentType.SOUNDBOARD]:
    ConversationMessageContentSoundBoard,
};

const compactComponents: Partial<
  Record<
    ConversationMessageContentType,
    JSXElementConstructor<IConversationMessageContentProps>
  >
> = {
  [ConversationMessageContentType.FILE]: ConversationMessageContentFileCompact,
};

export const ConversationMessageContent = ({
  message,
  compact,
  ...rest
}: IConversationMessageContentProps) => {
  const Component = components[message.contentType];
  const CompactComponent = compactComponents[message.contentType];

  if (!Component) {
    return null;
  }

  if (compact && CompactComponent) {
    return <CompactComponent message={message} {...rest} />;
  }

  return (
    <>
      <Component message={message} compact={compact} {...rest} />
      {!!message.mediaRef &&
        !!message.content &&
        message.contentType !== ConversationMessageContentType.AUDIO && (
          <ConversationMessageContentText
            message={message}
            compact={compact}
            {...rest}
          />
        )}
    </>
  );
};
